export default theme => ({
  root: {},
});
